export default __webpack_public_path__ + "static/media/realestateservice.6b671bda.png";